<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    title="下属管理"
    :visible="dialogVisible"
    :before-close="handleClose"
    :append-to-body="true"
    :wrapperClosable="false"
    :close-on-press-escape="false"
  >
    <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <div style="padding: 20px; height: 100%">
      <eco-table
        v-if="dialogVisible"
        @load="loadData"
        :data="data"
        :pageResult="pageResult"
        :selection="true"
        :show-export="false"
        :show-custom-column="false"
        :quick-search-props="[{ prop: 'UNDER_USER_NAME_', label: '姓名' }]"
        :default-querys="[
          { property: 'USER_ID_', value: this.orgUserId },
          { property: 'ORG_ID_', value: this.orgId }
        ]"
        ref="userRoleTable"
      >
        <template v-slot:toolbar>
          <el-button size="small" @click="showUserDialog()" type="primary">添加下属</el-button>
          <fe-delete-button :url="roleDeleteUrl" :htTable="$refs.userRoleTable" pk="id" parameter="ids">删除</fe-delete-button>
        </template>
        <template>
          <eco-table-column type="index" width="50" align="center" label="序号" />
          <eco-table-column prop="id" label="主键" :sortable="true" hidden />
          <eco-table-column prop="underUserName" label="下属姓名" width="300" :sortable="true" :show-overflow-tooltip="true" />
          <eco-table-column prop="createTime" label="创建时间" />
        </template>
      </eco-table>
    </div>
    <eip-user-dialog ref="eipUserDialog" @onConfirm="addUnderUser" append-to-body />
  </el-drawer>
</template>
<script>
import orgrequest from '@/api/org.js'
import EipUserDialog from '@/components/dialog/EipUserDialog.vue'

export default {
  name: 'under-user-table',
  props: ['userId', 'orgId'],
  components: {
    EipUserDialog
  },
  computed: {
    roleDeleteUrl: function () {
      return `${window.context.uc}/api/org/v1/userUnder/delUnderUserByIds`
    }
  },
  data() {
    return {
      dialogVisible: false,
      isSubmit: true,
      data: [],
      drawerSize: '70%',
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      roleCode: '',
      orgUserId: ''
    }
  },
  watch: {},
  created() {},
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    showDialog(orgUserId) {
      this.orgUserId = orgUserId
      this.dialogVisible = true
    },
    dialogCancle() {
      this.dialogVisible = false
    },
    loadData(param, cb) {
      orgrequest
        .getUserUndersPage(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    showUserDialog() {
      this.$refs.eipUserDialog.showDialog()
    },
    addUnderUser(selection) {
      if (!selection || selection.length == 0) {
        this.$message.error('请至少选择一个用户')
        return
      }
      let accounts = []
      for (let user of selection) {
        accounts.push(user.account)
      }
      let param = {}
      param.orgId = this.orgId
      param.account = this.userId
      param.underAccounts = accounts.join(',')
      orgrequest.setUnderUsers(param).then((data) => {
        if (data.state) {
          this.$message({
            message: data.message,
            type: 'success',
            showClose: true
          })
          this.$refs.userRoleTable.load()
          return
        }
        this.$message.error(data.message || '分配用户失败')
      })
    }
  }
}
</script>
<style scoped>
div[aria-invalid='true'] >>> .el-input__inner,
div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
